import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import Banner from './Banner';
import InsideContact from './InsideContact';


class BusinessContinuity extends Component {

    omponentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <div>
                <Banner
                    headText="Business Continuity"
                    subHeadText="Our customized continuity programs will help your business survive the unexpected"
                    subBoldText="INNOVATIVE. AFFORDABLE. PRACTICAL."
                    img="interior-1.jpg"
                />
                <div className="main-container">
                    <div className="container">
                        <div className="row">


                            <div className="col-lg-9 col-md-6 col-sm-12 margin5-0">
                                <h4>PREDICTABLE UNPREDICTABILITY</h4>
                                <p>
                                    Life happens in the most unpredictable ways. Business stopping events often give little warning.  
                                    Severe weather, faulty equipment, irrational employees, or viral attacks rarely give advance notice 
                                    of their grievous intentions. Worse, remedies to facilitate speedy recoveries from such stopages are
                                    often ignored or are the stepchild of budgetary restraints. We read about them all the time, but often
                                    give little thought to them actually happening to us. Yet if we learn anything in life, it's that the
                                    unpredictable is only minutes away.
                                </p>
                                <br />
                                <h4>A STITCH IN TIME REALLY DOES SAVE NINE</h4>
                                <p>
                                    At Automated Concepts we understand the crippling impact an unforeseen technology shutdown can have on a SMB.
                                    It’s like instantly losing your right hand in the middle of the big game. Worse actually. A loss of productivity
                                    means a loss of revenue, something no small business can endure indefinitely. Our experts can craft a business
                                    continuity and recovery package that’s just right for your small to medium business. We are proactive about the
                                    continuity of your business data and technology, so that you won’t have to expend inordinate amounts of time picking
                                    up the pieces when a catastrophic event hits.
                                </p>
                                <br />
                                <h4>BUSINESS CONTINUITY PLANS: YOUR BUSINESS ARK DURING THE STORM</h4>
                                <p>
                                    We offer a wide variety of solutions that can be customized to address just what you need when you need it most. 
                                    Whether it is offsite data storage and integrity, redundancy in applications or processes, harded gateways or hardware,
                                    or any other mission critical technology your business relies on, we can craft a solution for you that will protect your
                                    data and productivity when you need it.  
                                    <br /><br />
                                    Woe to any business that isn't prepared for the risks they face in this day and age.
                                    But that doesn’t have to be your business. 
                                    Contact us today to let us share with you how your business can be prepared for tomorrow.
                                    Surprisingly affordable. Dependably reliable.

                                </p>
                            </div>

                            <InsideContact />

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(BusinessContinuity);


// WEBPACK FOOTER //
// ./src/components/BusinessContinuity.js